import React from 'react';

import TextBlock from 'common/components/Placeholder/components/TextBlock/TextBlock';

import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

import styles from './IntroPlaceholder.module.scss';

const IntroPlaceholder = () => (
  <div className={styles.CompanyBoxPlaceholder}>
    <div className={styles.ContentWrapper}>
      <TextBlock
        rows={5}
        color={styles.PlaceholderDefaultColor}
        className={styles.CompanyBoxText}
      />
      <TextBlock
        rows={4}
        color={styles.PlaceholderDefaultColor}
        className={styles.ReportBoxText}
      />
    </div>
    <div className={styles.NavList}>
      <ContentBar className={styles.NavTitle} />
      <ContentBar className={styles.NavItems} />
    </div>
    <div className={styles.CompanyWrapper}>
      <ContentBar className={styles.CompanyTitle} />
      <div className={styles.CompanyBarBox}>
        <ContentBar className={styles.CompanyBar} />
        <ContentBar className={styles.CompanyBar} />
        <ContentBar repeat={6} className={styles.CompanyBar} />
      </div>
    </div>
  </div>
);

export default IntroPlaceholder;



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/placeholder/IntroSection/IntroPlaceholder.js